<template>
  <div>
    <h3><strong>Segnalazioni</strong></h3>
    <!-- <hr> -->
    <div class="row" style="margin-bottom:20px;margin-left:5px">
      <div class="rectangle-prestazioni" style="background-color:#7b7b7b;margin-bottom:10px">
        <h4 style="color:white;margin-top:15px;margin-right:5px;margin-left:5px"><strong>Nessuna prestazione inserita</strong></h4>
        <p style="font-size:14px;color:white;margin-top:40px;">
          <span style="margin-right:35px;text-align:left">Prestazioni</span>
          <span style="margin-left:35px;text-align:right;">{{tot_prestazioni}}</span>
        </p>
      </div>
      <div class="rectangle-prestazioni" style="background-color:#A9A9A9;margin-bottom:10px">
        <h4 style="color:white;margin-top:15px;margin-right:5px;margin-left:5px"><strong>Nessun soggetto inserito</strong></h4>
        <p style="font-size:14px;color:white;margin-top:40px;">
          <span style="margin-right:35px;text-align:left">Anagrafica Soggetti</span>
          <span style="margin-left:35px;text-align:right;">{{tot_soggetti}}</span>
        </p> 
        </div>
      <div class="rectangle-prestazioni" style="background-color:#A9A9A9;margin-bottom:10px">
        <h4 style="color:white;margin-top:15px;margin-right:5px;margin-left:5px"><strong>Documento identificativo assente</strong></h4>
        <p style="font-size:14px;color:white;">
          <span style="margin-top:40px;margin-right:35px;text-align:left">Anagrafica Soggetti</span>
          <span style="margin-top:40px;margin-left:35px;text-align:right;">0</span>
        </p> 
        </div>
      <div class="rectangle-prestazioni" style="background-color:#A9A9A9;margin-bottom:10px">
        <h4 style="color:white;margin-top:15px;margin-right:5px;margin-left:5px"><strong>Valutazione cliente non compilata</strong></h4>
        <p style="font-size:14px;color:white;">
          <span style="margin-top:40px;margin-right:35px;text-align:left">Adeguata Verifica</span>
          <span style="margin-top:40px;margin-left:35px;text-align:right;">{{tot_tab_A_nonComp}}</span>
        </p> 
      </div>
    </div>
    <h3><strong>Scadenzario</strong></h3>
    <hr>
    <div class="row" style="margin-left:5px">
      <div class="smaller-rectangle" style="background-color: #A9A9A9;">
        <p style="text-align:right;font-size:16px;color:white;margin-right:10px;margin-top:5px"><strong>0</strong></p> 
        <p style="text-align:left;font-size:14px;color:white;margin-left:10px;position:absolute;bottom:0">Tutte</p> 
      </div>
      <div class="smaller-rectangle" style="background-color: #ce5656;">
        <p style="text-align:right;font-size:16px;color:white;margin-right:10px;margin-top:5px"><strong>0</strong></p> 
        <p style="text-align:left;font-size:14px;color:white;margin-left:10px;position:absolute;bottom:0">Scadute</p> 
      </div>
      <div class="smaller-rectangle" style=" background-color:#e38c2f;">
        <p style="text-align:right;font-size:16px;color:white;margin-right:10px;margin-top:5px"><strong>0</strong></p> 
        <p style="text-align:left;font-size:14px;color:white;margin-left:10px;position:absolute;bottom:0">In scadenza</p> 
      </div>
    </div>
    <hr>
    <h3 style="margin-top:20px">Prossime 10 in scadenza</h3>
    <div class="row">
      <div class="col">
        <table class="table">
        <tr>
          <th>SCADENZA</th>
          <th>CF</th>
          <th>DENOMINAZIONE</th>
          <th>ADEGUATA VERIFICA</th>
        </tr>
        <tr v-for="valori in status.SCADENZE" v-bind:key="valori.ID">
          <td v-if="valori.SCADENZA != null">{{getDate(valori.SCADENZA)}}</td>
          <td v-else></td>
          <td>{{valori.CF}}</td>
          <td>{{valori.DENOMINAZIONE}}</td>
          <td>{{valori.ADEGUATA_VERIFICA}}</td>
        </tr>
      </table>
      </div>
    </div>

    <h3 style="margin-top:20px">Primi 10 documenti in scadenza</h3>
    <div class="row">
      <div class="col">
        <table class="table">
        <tr>
          <th>DATA SCADENZA</th>
          <th>CF AZIENDA</th>
          <th>CF SOGGETTO</th>
        </tr>
        <tr v-for="(valori, index) in documenti_scadenza" v-bind:key="index">
          <td v-if="valori.EXPIRE_DATE != null">{{getDate(valori.EXPIRE_DATE)}}</td>
          <td v-else></td>
          <td><router-link style="color:#000000; text-decoration:underline" :to="'/anagrafica-soggetti?idCliente='+valori.ANTIRIC_SOGGETTO.ANTIRIC_CLIENTEs[0].ID">{{valori.ANTIRIC_SOGGETTO.ANTIRIC_CLIENTEs[0].CF}}</router-link></td>
          <td>{{valori.ANTIRIC_SOGGETTO.CF}}</td>
        </tr>
      </table>
      </div>
    </div>

  </div>
</template>
<script>
import AntiriciclaggioServices from '@/services/AntiriciclaggioServices';
import Services from '@/services/Services';
import moment from 'moment';

export default {
  components: { },
  data() {
    return {
      status: [],
      tot_tab_A: null,
      tot_clienti: null,
      tot_soggetti: null,
      tot_prestazioni: null,
      tot_tab_A_nonComp: null,
      documento_identificativo: null,
      valutazione_cliente_non_compilata: null,
      documenti_scadenza: null
    }
  },
  methods: {
     getDate(date) {
        return moment(String(date)).format('DD/MM/YYYY');
    },

    getStatus: async function() {
      let errore = 0;
      await AntiriciclaggioServices.getStatus()
      .then(response => { this.status = response.data})
      .catch( function (error) {
          if(error.response.status == 401){
              errore = error.response.status;
          }
      });
      if (errore == 401) {
          let value = await Services.refreshTokenFunction();
          if (value) { await this.getStatus(); }
      }
      // console.log(`status: `);
      // console.log(this.status);

      this.tot_tab_A = this.status.TOT_TAB_A;
      this.tot_clienti = this.status.TOT_CLIENTI;
      this.tot_soggetti = this.status.TOT_SOGGETTI;
      this.tot_prestazioni = this.status.TOT_PRESTAZIONI;
      this.tot_tab_A_nonComp = this.status.TOT_TAB_A_NO_COMP;
      //  this.documento_identificativo
      // this.valutazione_cliente_non_compilata = this.tot_clienti - this.tot_tab_A;
      console.log(`tot_tab_A: ${this.tot_tab_A} , tot_clienti: ${this.tot_clienti}, tot_soggetti: ${this.tot_soggetti}, tot_prestazioni: ${this.tot_prestazioni}, tot_tab_A_nonComp: ${this.tot_tab_A_nonComp},`);
      this.documenti_scadenza = this.status.DOCUMENTI_SCADENZA;
      
   },

    main: async function() {
      await this.getStatus();
    },
  },

  mounted() {
      this.main();
    }
};
</script>
<style>
  h3 {
    color:black;
    text-align: left;
  }
  .rectangle-prestazioni {
    height: 120px;
    width: 250px;
    display: inline;
    margin-right: 10px;
    float: left;
  }
  
  .smaller-rectangle{
    height: 80px;
    width: 150px;
    margin-bottom: 10px;
    margin-right:10px;
    position: relative; 
    float: left;
  }
</style>
